export default function CommunityStats() {
  const stats = [
    { number: '100万+', label: '注册开发者', icon: 'ri-user-line' },
    { number: '30,000+', label: '技术文章', icon: 'ri-article-line' },
    { number: '500+', label: '开源项目', icon: 'ri-git-repository-line' },
    { number: '15万+', label: '日活跃用户', icon: 'ri-fire-line' },
    { number: '200万+', label: '月互动次数', icon: 'ri-chat-1-line' },
    { number: '98%', label: '用户好评率', icon: 'ri-heart-line' },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-background-50 mb-3">
            社区数据一览
          </h2>
          <p className="text-primary-100 max-w-xl mx-auto text-base">
            用数据见证1024社区的成长，每一位开发者都是社区宝贵的财富
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 rounded-lg bg-primary-600/30 border border-primary-400/20"
            >
              <span className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-primary-400/30 mb-3">
                <i className={`${stat.icon} text-primary-100 text-lg`}></i>
              </span>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1 whitespace-nowrap">
                {stat.number}
              </div>
              <div className="text-xs text-primary-200 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}